import {GET_CHATBOT_QUESTIONS} from '../../shared/constants/ActionTypes';

const initialState = {
  questions: [],
  total: 0,
};

const chatbotQuestionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHATBOT_QUESTIONS:
      return {
        ...state,
        questions: [...action.payload.questions].sort(
          (a, b) => (Number(a.order) || 0) - (Number(b.order) || 0),
        ),
        total: action.payload.total,
      };
    default:
      return state;
  }
};

export default chatbotQuestionReducer;
